import { useCallback, useMemo, useState } from 'react';

import type { PlayVideo } from '../contexts/PlayVideoContext';

type NotPlaying = Readonly<{
  isPlaying: false;
  play: PlayVideo;
}>;

export type PlayedVideo = {
  title: string;
  videoId: string;
};

type Playing = Readonly<{
  isPlaying: true;
  played: PlayedVideo;
  close: () => void;
}>;

export type PlayingState = Playing | NotPlaying;

export function usePlayingState(): PlayingState {
  const [playedVideoId, setPlayedVideoId] = useState<string | undefined>(undefined);
  const [playedVideoName, setPlayedVideoName] = useState<string | undefined>(undefined);
  const closeVideoPlayed = useCallback(() => setPlayedVideoId(undefined), []);

  const play = useCallback((videoId: string, name?: string) => {
    setPlayedVideoId(videoId);
    setPlayedVideoName(name);
  }, []);

  const isPlaying = useMemo(() => {
    return playedVideoId !== undefined;
  }, [playedVideoId]);

  return isPlaying
    ? {
        isPlaying: true,
        played: {
          videoId: playedVideoId!,
          title: playedVideoName!,
        },
        close: closeVideoPlayed,
      }
    : {
        isPlaying: false,
        play,
      };
}
